import styled from 'styled-components';

import { Box } from 'components/Box/Box';
import { Text } from 'components/Text/Text';
import { colors, fontWeights } from 'theme/theme';
import { getStaticImageSrc } from 'utils/getImageSrc';

const GradfairCalendarNotificationContentLocationType = styled.div`
  display: inline-block;
  font-size: 12px;
  color: white;
  background-color: #68bd53;
  border-radius: 6px;
  padding: 2px 6px;
  text-transform: uppercase;
`;

export function GradfairCalendarNotificationContent() {
  return (
    <Box display="flex">
      <Box>
        <img
          src={getStaticImageSrc('fair/grad-fairs-calendar-ad.svg')}
          height="100px"
          alt=""
        />
      </Box>
      <Box marginLeft="10px">
        <Text
          fontWeight={fontWeights.normal}
          fontSize="12px"
          $textTransform="uppercase"
          color={colors.lightContentGrey}
          marginBottom="5px"
        >
          {getText('Free event')}
        </Text>
        <Text fontWeight={fontWeights.semiBold}>
          {getText('Idealist Grad School Fair')}
        </Text>
        <Text fontWeight={fontWeights.normal} fontSize="14px">
          October 9, 2024
        </Text>

        <GradfairCalendarNotificationContentLocationType>
          {getText('On-site')}
        </GradfairCalendarNotificationContentLocationType>
        <Text
          display="inline"
          fontWeight={fontWeights.normal}
          fontSize="14px"
          color={colors.lightContentGrey}
          marginLeft="5px"
        >
          New York City
        </Text>
      </Box>
    </Box>
  );
}
